import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const PortalClienteFinanceiroList = props => <DefaultDataTable data={props} />;